/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import Stack from '@mui/material/Stack';
import { useEffect, useState } from 'react';
import ButtonPrimary from 'components/Buttons/ButtonPrimary/ButtomPrimary.component';
import TextInputField from 'components/inputs/TextField/TextField.component';
import { FormGlobal } from 'styles/Global.styles';
import { maskInput, useScreenSize } from 'utils/helpers';
import { maskCpfCnpj } from 'utils/maskCpfCnpj';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { TableCadastroProps } from '@typings/componentables';
import { useApi } from 'hooks/userApi';
import { LoadingContext } from 'context/Loading/LoadingContext';
import { FormProduto, FormVendedor } from '@typings/cadastro';
import ButtonSecondary from 'components/Buttons/ButtonSecondary/ButtonSecondary.component';
import ButtonTerciary from 'components/Buttons/ButtonTerciary/ButtonTerciary.component';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';

const api = useApi();

type TEditVendedorProps = {
  setEdit: () => void;
  dado: any;
};

const CloneProduto = ({ setEdit, dado }: TEditVendedorProps) => {
  const [active, setSalvar] = useState(false);
  const [categorias, setCategorias] = useState([]);
  const [categoriasFormatado, setCategoriasFormatado] = useState([]);

  const [cores, setCores] = useState([]);
  const [coresFormatado, setCoresFormatado] = useState([]);

  const [foto, setFoto] = useState<File | undefined>(undefined);

  const {
    loading,
    setLoading,
    loadingMensagem,
    setLoadingMensagem,
    loadingBtn,
    setLoadingBtn,
    loadingAction,
    setLoadingAction,
    clearLoading,
    setClearLoading,
  }: any = React.useContext(LoadingContext);

  const isBreak = useScreenSize(570);
  const schema = z.object({
    NCM: z.string().nonempty({ message: 'O NCM é obrigatório.' }),
    SKU: z.string().nonempty({ message: 'O SKU é obrigatório.' }),
    altura: z.string().nonempty({ message: 'A altura é obrigatório.' }),
    categoria: z.string().nonempty({ message: 'A categoria é obrigatório.' }),
    cores: z.string().nonempty({ message: 'A Cor é obrigatório.' }),
    frete: z.string().nonempty({ message: 'O frete é obrigatório.' }),
    imposto: z.string().nonempty({ message: 'O imposto é obrigatório.' }),
    ipi: z.string().nonempty({ message: 'O ipi é obrigatório.' }),
    largura: z.string().nonempty({ message: 'A largura é obrigatório.' }),
    margin: z.string().nonempty({ message: 'A margin é obrigatório.' }),
    nome: z.string().nonempty({ message: 'A nome é obrigatório.' }),
    precoBase: z.string().nonempty({ message: 'O preço Base é obrigatório.' }),
    precoConsumo: z.string().nonempty({ message: 'O preço Consumo é obrigatório.' }),
    precoRevenda: z.string().nonempty({ message: 'O preço Revenda é obrigatório.' }),
    profundidade: z.string().nonempty({ message: 'A profundidade é obrigatório.' }),
    isActive: z.boolean().default(true),
  });

  const { clearErrors, handleSubmit, setValue, formState, watch } = useForm({
    defaultValues: {
      NCM: '',
      SKU: '',
      altura: String(dado?.altura) || '',
      categoria: '*',
      frete: dado?.frete || '',
      imposto: String(dado?.imposto) || '',
      ipi: String(dado?.imposto) || '',
      isActive: dado?.isActive || false,
      largura: String(dado?.largura) || '',
      margin: String(dado?.margin) || '',
      nome: dado?.nome || '',
      precoBase: String(dado?.precoBase) || '',
      precoConsumo: String(dado?.precoConsumo) || '',
      precoRevenda: String(dado?.precoRevenda) || '',
      profundidade: String(dado?.profundidade) || '',
      cores: '*',
    },
    resolver: zodResolver(schema),
  });

  const dadosForm = [
    { label: 'Nome do produto', type: 'text', campo: 'nome', select: false, option: [] },
    { label: 'Categoria', type: 'text', campo: 'categoria', select: true, option: categoriasFormatado },
    { label: 'Preço Base', type: 'number', campo: 'precoBase', select: false, option: [] },
    { label: 'Preço Consumo', type: 'number', campo: 'precoConsumo', select: false, option: [] },
    { label: 'Preço Revenda', type: 'number', campo: 'precoRevenda', select: false, option: [] },
    { label: 'IPI', type: 'number', campo: 'ipi', select: false, option: [] },
    { label: 'Imposto', type: 'number', campo: 'imposto', select: false, option: [] },
    { label: 'Frete', type: 'number', campo: 'frete', select: false, option: [] },
    { label: 'Margin', type: 'number', campo: 'margin', select: false, option: [] },
    { label: 'Altura em mm', type: 'number', campo: 'altura', select: false, option: [] },
    { label: 'Largura em mm', type: 'number', campo: 'largura', select: false, option: [] },
    { label: 'Profundidade em mm', type: 'number', campo: 'profundidade', select: false, option: [] },
    { label: 'SKU', type: 'text', campo: 'SKU', select: false, option: [] },
    { label: 'NCM', type: 'text', campo: 'NCM', select: false, option: [] },
    // { label: 'Cor', type: 'text', campo: 'cores', select: true, option: coresFormatado },
    // { label: 'Foto', type: 'file', campo: 'fotos', select: false, option: [] },
    // { label: 'Ativo', type: 'checkbox', campo: 'isActive', select: false, option: [] },
  ];

  const onSubmit = async (data) => {
    setLoading(true);
    const msg = 'Cadastrado com sucesso!';
    if (!cores) return;

    const arrReq = {
      nome: watch('nome'),
      categoria: categorias.find((obj) => obj?.nome === watch('categoria')),
      precoBase: Number(watch('precoBase')),
      precoConsumo: Number(watch('precoConsumo')),
      precoRevenda: Number(watch('precoRevenda')),
      ipi: Number(watch('ipi')),
      imposto: Number(watch('imposto')),
      frete: Number(watch('frete')),
      margin: Number(watch('margin')),
      altura: Number(watch('altura')),
      largura: Number(watch('largura')),
      profundidade: Number(watch('profundidade')),
      SKU: watch('SKU'),
      NCM: watch('NCM'),
      isActive: true,
      caracteristicas: [{ id: dado?.caracteristicas[0].id }],
    };

    const formData = new FormData();
    const cor = cores.find((obj) => obj?.nome === watch('cores'));
    if (foto !== undefined) {
      const arrCaracteristica = [{ cores: [{ id: cor.id }], fotos: [] }];
      formData.append('image', foto);

      const arrFile = {
        content_length: `${foto.size}`,
      };

      const responseFile = await api.file('/foto', formData, arrFile);

      if (responseFile && responseFile.status) {
        arrCaracteristica[0].fotos = [{ id: responseFile.mensagem.foto.id }];

        const newCaracteristica = await api.post('/caracteristica/', arrCaracteristica[0]);

        if (newCaracteristica && newCaracteristica.status) {
          const id = newCaracteristica.mensagem.id;
          arrReq.caracteristicas = [{ id }];

          const attProduto = await api.post(`/produto/`, arrReq);

          if (attProduto) {
            if (attProduto.status) {
              setLoadingMensagem(msg);
              setLoadingBtn('OK');
              window.location.reload();
            } else {
              const msg2 = attProduto.status;
              setLoadingMensagem(msg2);
              setLoadingBtn('OK');
            }
          } else {
            const msg2 = 'Houve um erro interno, tente mais tarde.';
            setLoadingMensagem(msg2);
            setLoadingBtn('OK');
          }
        } else {
          const msg2 = 'Houve um erro interno, tente mais tarde.';
          setLoadingMensagem(msg2);
          setLoadingBtn('OK');
        }
      } else {
        const msg2 = 'Houve um erro interno, tente mais tarde.';
        setLoadingMensagem(msg2);
        setLoadingBtn('OK');
      }
    } else {
      const arrCaracteristica = [{ cores: [{ id: cor.id }], fotos: [{ id: dado?.caracteristicas[0].fotos[0].id }] }];

      const newCaracteristica = await api.post('/caracteristica/', arrCaracteristica[0]);

      if (newCaracteristica && newCaracteristica.status) {
        const id = newCaracteristica.mensagem.id;
        arrReq.caracteristicas = [{ id }];

        const attProduto = await api.post(`/produto/`, arrReq);

        if (attProduto) {
          if (attProduto.status) {
            setLoadingMensagem(msg);
            setLoadingBtn('OK');
            window.location.reload();
          } else {
            const msg2 = attProduto.mensagem || 'Erro desconhecido';
            setLoadingMensagem(msg2);
            setLoadingBtn('OK');
          }
        } else {
          const msg2 = 'Houve um erro interno, tente mais tarde.';
          setLoadingMensagem(msg2);
          setLoadingBtn('OK');
        }
      } else {
        const msg2 = 'Houve um erro interno, tente mais tarde.';
        setLoadingMensagem(msg2);
        setLoadingBtn('OK');
      }
    }
  };

  function handleChange(name: FormProduto, event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    const value = event.target.value;

    if (name === 'isActive') {
      if (value === 'true') {
        setValue(name, true);
      } else {
        setValue(name, false);
      }
    }

    setValue(name, value);

    if (formState.errors[`${name}`]) {
      clearErrors(name);
    }
  }

  useEffect(() => {
    async function load() {
      const response = await api.get('/categoria/');

      if (response) {
        const newObjeto = await response.map((objeto) => objeto?.nome);
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        dado?.categoria?.nome && newObjeto
          ? setValue(
              'categoria',
              newObjeto.find((obj) => obj === dado?.categoria?.nome),
            )
          : null;
        await setCategoriasFormatado(newObjeto);
        await setCategorias(response);
      }
    }
    load();
  }, []);

  useEffect(() => {
    async function load() {
      const response = await api.get('/cor/');

      if (response) {
        const newObjeto = await response.map((objeto) => objeto?.nome);
        await setCoresFormatado(newObjeto);
        await setCores(response);
      }
    }

    load();
  }, []);

  useEffect(() => {
    const find = categoriasFormatado.find((obj) => obj === dado?.categoria?.nome);
    setValue('categoria', find);
  }, [categorias, categoriasFormatado]);

  useEffect(() => {
    const find = coresFormatado.find((obj) => obj === dado?.caracteristicas[0]?.cores[0]?.nome);
    setValue('cores', find);
  }, [cores, coresFormatado]);

  const isCampoInFormCliente = (campo: string): campo is FormProduto => {
    return (
      campo === 'NCM' ||
      campo === 'SKU' ||
      campo === 'altura' ||
      campo === 'categoria' ||
      campo === 'frete' ||
      campo === 'imposto' ||
      campo === 'ipi' ||
      campo === 'isActive' ||
      campo === 'largura' ||
      campo === 'margin' ||
      campo === 'nome' ||
      campo === 'precoBase' ||
      campo === 'precoConsumo' ||
      campo === 'precoRevenda' ||
      campo === 'cores' ||
      campo === 'fotos' ||
      campo === 'profundidade'
    );
  };

  const handleFoto = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (!event) return;

    const inputElement = event.target as HTMLInputElement;
    const files = inputElement.files;

    if (files && files.length > 0) {
      const file = files[0];
      if (!file) return;
      setFoto(file);
    }
  };

  return (
    <Stack spacing={2}>
      <FormGlobal noValidate onSubmit={handleSubmit(onSubmit)}>
        {dadosForm &&
          dadosForm.map((dados, index) => (
            <>
              {dados.campo !== 'isActive' && dados.campo !== 'fotos' && (
                <TextInputField
                  key={index}
                  label={dados.label}
                  type={dados.type}
                  selected={dados.select}
                  nome={dados.campo}
                  dados={dados.option}
                  mask={maskInput(dados.campo)}
                  style={{ width: isBreak ? '100%' : '49%' }}
                  defaultValueText={'-- Selecione --'}
                  value={isCampoInFormCliente(dados.campo) ? watch(dados.campo) : null}
                  error={!!formState.errors[dados.campo]}
                  helperText={formState.errors[dados.campo] ? formState.errors[dados.campo].message : ''}
                  onChange={(nome) => (isCampoInFormCliente(dados.campo) ? handleChange(dados.campo, nome) : null)}
                />
              )}
              {dados.campo === 'fotos' && (
                <div style={{ width: isBreak ? '100%' : '49%' }}>
                  <input type="file" onChange={handleFoto} />
                </div>
              )}
              {dados.campo === 'isActive' && (
                <Checkbox
                  disabled
                  style={{ width: isBreak ? '100%' : '49%' }}
                  checked={watch(dados.campo)}
                  onChange={(nome) => (isCampoInFormCliente(dados.campo) ? handleChange(dados.campo, nome) : null)}
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                />
              )}
            </>
          ))}
      </FormGlobal>
      <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'center' }}>
        <ButtonPrimary onClick={handleSubmit(onSubmit)} typeSubmit={false} label={'Duplicar produto'} />
      </div>
      <ButtonTerciary onClick={setEdit} label={'Cancelar'} typeSubmit={false} />
    </Stack>
  );
};
export default CloneProduto;
